export const APPROVAL_STATUSES = ['PENDING', 'APPROVED', 'REJECTED'];
export function normalizeApproval(item) {
  if (!item || typeof item !== 'object' || !item.id || !item.type || !APPROVAL_STATUSES.includes(item.status)) throw new Error('Invalid approval record.');
  return item;
}
export function decisionPayload(item, decision, reason) {
  normalizeApproval(item);
  if (item.status !== 'PENDING') throw new Error('This request is no longer pending. Refresh the queue.');
  if (!['APPROVE', 'REJECT'].includes(decision)) throw new Error('Invalid decision.');
  const explanation = String(reason || '').trim();
  if (decision === 'REJECT' && !explanation) throw new Error('Provide a reason for rejection.');
  return {requestId:item.id, expectedVersion:item.version ?? null, decision, reason:explanation};
}
export function selectApprovals(items,{status='PENDING',type='',query=''}={}) {
  return items.filter(item => (!status || item.status===status) && (!type || item.type===type) && (!query || [item.title,item.id,item.requesterName,item.subjectName].some(value=>String(value || '').toLowerCase().includes(query.trim().toLowerCase()))));
}
